<template>
  <div class="ui-container">
    <ui-row align-h="center">
      <ui-col :lg="10">
        <ui-card>
          <editor ref="editor"></editor>
        </ui-card>
      </ui-col>
    </ui-row>
  </div>
</template>
<script>
import api from "../api/index";
import Editor from "../components/Editor.vue";
import { mapGetters } from "vuex";
import event from "../utils/event.js";
export default {
  data() {
    return {
      article: null,
      loading: false,
      changed: false,
      bookId: "",
    };
  },
  computed: {
    ...mapGetters(["authInfo"])
  },
  components: {
    Editor
  },
  methods: {
    change() {
      this.changed = true;
    },
    getContent(type) {
      this.$refs["editor"]
        .getHtml()
        .then(html => {
          this.save(html, type);
        })
        .catch(() => {});
    },
    jump(url) {
      if (this.$route.params.eventId) {
        this.$router.go(-1)
      } else {
        this.$router.push(url);
      }
    },
    save(html, type) {
      this.loading = true;
      if (!this.article) {
        api
          .publishArticle({
            content: html,
            bookId: this.bookId,
            isDraft: type == "draft" ? true : false
          })
          .then(res => {
            this.$refs["editor"].changed = false;
            this.jump(`/@${res.data.bookAuthor}/${res.data.bookCode}/articleList`)
          });
      } else {
        this.article.content = html;
        this.article.isDraft = type == "draft" ? true : false;
        api
          .updateArticle(this.article)
          .then(res => {
            this.$refs["editor"].changed = false;
            this.loading = false;
            this.jump(`/@${res.data.bookAuthor}/${res.data.bookCode}/articleList`)
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    notFound() {
      this.$UiToast({
        type: "error",
        message: "Why are you here?",
        onClose: () => {
          this.$router.push("/index");
        }
      });
    },
    fetchData() {
      if (this.$route.params.articleId) {
        api.getContentById(this.$route.params.articleId).then(response => {
          this.article = response.data.content;
          this.bookId = this.article.bookId;
          this.$refs["editor"].setHtml(
            this.article.content,
            this.article.fileHash
          );
        });
      } else if (this.$route.params.username && this.$route.params.code) {
        api
          .getBookByCode({
            username: this.$route.params.username,
            code: this.$route.params.code
          })
          .then(res => {
            this.bookId = res.data.content.id;
          })
          .catch(() => {
            this.notFound();
          });
      } else if (this.$route.params.eventId) {
        this.bookId = this.$route.params.eventId
      } else {
        this.notFound();
      }
    }
  },
  mounted() {
    this.fetchData();
    event.$on("add-article", this.getContent);
  },
  beforeDestroy() {
    event.$off("add-article", this.getContent);
  },
  beforeRouteLeave(to, from, next) {
    if (this.$refs["editor"].changed && this.$route.name == "ArticleEdit") {
      const answer = window.confirm(
        "Do you really want to leave? you have unsaved changes!"
      );
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }
};

</script>
